import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import {Concept} from 'types';
import type {RootState} from 'store/types';
import type {BulkUpdateItemsState} from './types';

const initialState: BulkUpdateItemsState = {
  type: Concept.work,
  itemIds: [],
};

const bulkUpdateItemsSlice = createSlice({
  name: 'bulkUpdateItems',
  initialState,
  reducers: {
    bulkUpdateItemsUpdated: (
      _state,
      action: PayloadAction<BulkUpdateItemsState>,
    ) => {
      return action.payload;
    },
    bulkUpdateItemsCleared: () => {
      return initialState;
    },
  },
});

export const {bulkUpdateItemsUpdated, bulkUpdateItemsCleared} =
  bulkUpdateItemsSlice.actions;
export const selectBulkUpdateItemsItemIds = (state: RootState) =>
  state.bulkUpdateItems.itemIds;
export const selectBulkUpdateItemsType = (state: RootState) =>
  state.bulkUpdateItems.type;

export default bulkUpdateItemsSlice;
